import { useEffect, useState } from "react";

interface SubmitClueModalProps {
  open: boolean;
  onClose: () => void;
}

export default function SubmitClueModal({ open, onClose }: SubmitClueModalProps) {
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!open) {
      setDone(false);
      return;
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground-950/50"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-lg rounded-lg bg-background-50 border border-background-200 p-6 kd-fade-up">
        <button
          type="button"
          onClick={onClose}
          aria-label="关闭"
          className="absolute top-4 right-4 w-9 h-9 rounded-md text-foreground-500 hover:text-foreground-900 hover:bg-background-100 flex items-center justify-center transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg w-5 h-5 flex items-center justify-center" />
        </button>

        {done ? (
          <div className="py-8 text-center">
            <span className="w-14 h-14 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center mx-auto">
              <i className="ri-check-line text-2xl w-7 h-7 flex items-center justify-center" />
            </span>
            <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
              线索已记录
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              核验组会在补齐原始出处后更新到对应合集，感谢你帮忙把时间线排清楚。
            </p>
            <button
              type="button"
              onClick={onClose}
              className="mt-6 h-10 px-5 rounded-md bg-foreground-950 text-background-50 text-sm font-label whitespace-nowrap cursor-pointer"
            >
              好的
            </button>
          </div>
        ) : (
          <>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">
              提交一条线索
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              请尽量附上原始出处，我们会先比对再决定标注为辟谣、反转还是待核实。
            </p>

            <div className="mt-5 space-y-4">
              <div>
                <label className="block text-xs font-label text-foreground-600 mb-1.5">
                  事件名称
                </label>
                <input
                  type="text"
                  placeholder="例如：某条录音剪辑之争"
                  className="w-full h-11 px-3 rounded-md bg-background-100 border border-background-200 text-sm font-label text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-label text-foreground-600 mb-1.5">
                  线索说明
                </label>
                <textarea
                  rows={3}
                  maxLength={500}
                  placeholder="描述你掌握的信息、时间点和可核验的原始链接…"
                  className="w-full resize-none px-3 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm font-label text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-label text-foreground-600 mb-1.5">
                  联系方式（选填）
                </label>
                <input
                  type="text"
                  placeholder="便于核验组回访确认细节"
                  className="w-full h-11 px-3 rounded-md bg-background-100 border border-background-200 text-sm font-label text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 h-11 rounded-md border border-background-300 text-foreground-700 text-sm font-label hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                取消
              </button>
              <button
                type="button"
                onClick={() => setDone(true)}
                className="flex-1 h-11 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label transition-colors whitespace-nowrap cursor-pointer"
              >
                提交线索
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}